var map = {
	"./css3.svg": "ER8m",
	"./feathersjs.svg": "//nF",
	"./html5.svg": "9WEv",
	"./js.svg": "9ciA",
	"./mongodb.svg": "2qy4",
	"./nodejs.svg": "lPXI",
	"./psql.svg": "8VwU",
	"./react.svg": "ha5S",
	"./vuejs.svg": "Z1xU",
	"./webpack.svg": "iVeO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B64m";